export const upperFirstLetter = (text) => `${text[0].toUpperCase()}${text.slice(1)}`
